import React from "react";
import { Button, Card, Header, List } from "semantic-ui-react";

import ISpouse from "../../../data/priest/Spouse";
import "../../../static/priestProfile.css";
import CardRow from "../CardRow";
import CardRowForDate from "../CardRowForDate";
import CardDropdownReligion from "../CardRowForReligion";

interface ISpouseCardProps {
    spouse: ISpouse;
    index: number;
    editMode: boolean;
    handleDelete: (index: number) => void;
    handleChangeOnSpouse: (labelName: string, value: any, index: number) => void;
}

const SpouseCard: React.FC<ISpouseCardProps> = (props: ISpouseCardProps) => {
    const { spouse, index, editMode, handleDelete, handleChangeOnSpouse } = props;

    const handleOnClick = () => {
        handleDelete(index);
    };

    return (
        <Card fluid>
            <Card.Content>
                <Card.Content>
                    {editMode ? (
                        <Button color="red" floated="right" icon="trash" id="deleteButton" inverted onClick={handleOnClick} />
                    ) : (
                        <Card.Header id="header">
                            <Header as="h2">{spouse.name}</Header>
                        </Card.Header>
                    )}
                </Card.Content>

                <Card.Description>
                    <List>
                        {editMode && (
                            <List.Item>
                                <CardRow data={spouse.name} editMode={editMode} index={index} labelName="name" setValue={handleChangeOnSpouse} />
                            </List.Item>
                        )}
                        <List.Item>
                            <CardRowForDate
                                data={spouse.birthDate}
                                editMode={editMode}
                                index={index}
                                labelName="birthDate"
                                setValue={handleChangeOnSpouse}
                            />
                        </List.Item>
                        <List.Item>
                            <CardRowForDate
                                data={spouse.marriageDate}
                                editMode={editMode}
                                index={index}
                                labelName="marriageDate"
                                setValue={handleChangeOnSpouse}
                            />
                        </List.Item>
                        <List.Item>
                            <CardRow data={spouse.job} editMode={editMode} index={index} labelName="job" setValue={handleChangeOnSpouse} />
                        </List.Item>
                        <List.Item>
                            <CardRow
                                data={spouse.fatherName}
                                editMode={editMode}
                                index={index}
                                labelName="fatherName"
                                setValue={handleChangeOnSpouse}
                            />
                        </List.Item>
                        <List.Item>
                            <CardRow
                                data={spouse.motherName}
                                editMode={editMode}
                                index={index}
                                labelName="motherName"
                                setValue={handleChangeOnSpouse}
                            />
                        </List.Item>
                        <List.Item>
                            <CardDropdownReligion
                                data={spouse.religion}
                                editMode={editMode}
                                index={index}
                                labelName="religion"
                                setValue={handleChangeOnSpouse}
                            />
                        </List.Item>
                    </List>
                </Card.Description>
            </Card.Content>
        </Card>
    );
};

export default SpouseCard;
